<template>
    <div v-if="issue_obj">
        <div>
            <h5 class="ml-3">Location Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <vs-input 
                        :value="issue_obj.data.id ? `Issue #${issue_obj.data.id}` : 'Auto Generated'"
                        label="* Issue ID"
                        readonly
                        class="w-full"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectDate :disabled="mode != 'e'" :selectedDate.sync="issue_obj.data.date_of_accident" label="Date of Accident" />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <label class="vs-input--label block">Direction</label>
                    <div class="flex mt-3 align-center">
                        <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="lhs">LHS</vs-radio>
                        <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="rhs" class="mx-3">RHS</vs-radio>
                        <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="bhs" class="mx-3">BHS</vs-radio>
                        <vs-radio :disabled="mode != 'e'" v-model="issue_obj.data.direction" vs-name="direction" vs-value="median" class="mx-3">Median</vs-radio>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.direction">
                        {{ api_errors.data.direction.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <label class="vs-input--label block">Chainage</label>
                    <vs-row class="mt-1">
                        <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-0 pr-1">
                            <div class="flex" style="align-items: center">
                                <label class="vs-input--label block mr-3">From</label>
                                <vs-input
                                    v-model="issue_obj.data.chainage_from"
                                    class="w-full"
                                    :disabled="mode != 'e'"
                                />
                            </div>
                            <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.chainage_from">
                                {{ api_errors.data.chainage_from.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="6" vs-sm="6" vs-lg="6" class="pl-1 pr-0">
                            <div class="flex" style="align-items: center">
                                <label class="vs-input--label block mr-3">To</label>
                                <vs-input
                                    v-model="issue_obj.data.chainage_to"
                                    class="w-full"
                                    :disabled="mode != 'e'"
                                />
                            </div>
                            <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.chainage_to">
                                {{ api_errors.data.chainage_to.join(', ') }}
                            </small>
                        </vs-col>
                    </vs-row>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <SelectForeign
                        :model.sync="issue_obj.assigned_reviewers"
                        label="Select Incident Manager"
                        placeholder="Type to Search..."
                        :multiple="true"
                        :load_initial="true"
                        :label_keys="['first_name', 'last_name']"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :close_on_select="false"
                        :disabled="mode != 'e'"
                        :use_cache="true"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.assigned_reviewers">
                        {{ api_errors.assigned_reviewers.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Time Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3" style="margin-left: 0%; width: 100%;">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                        <label for class="vs-input--label">Time of Accident(HH:MM)</label>
                        <div class="vs-con-input">
                            <VueTimepicker auto-scroll v-model="issue_obj.data.time" :disabled="mode != 'e'"></VueTimepicker>
                        </div>
                    </div>
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.time">
                        {{ api_errors.data.time.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Incident Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <vs-input
                        label="Incident"
                        class="w-full"
                        v-model="issue_obj.data.incident"
                        :disabled="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.incident">
                        {{ api_errors.data.incident.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Other Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <vs-input
                        label="Action Taken"
                        class="w-full"
                        v-model="issue_obj.data.action_taken"
                        :disabled="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.action_taken">
                        {{ api_errors.data.action_taken.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                    <vs-input
                        label="Remarks"
                        class="w-full"
                        v-model="issue_obj.data.remarks"
                        :disabled="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.data && api_errors.data.remarks">
                        {{ api_errors.data.remarks.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <div>
            <h5 class="ml-3">Image Details</h5>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block mb-1" v-if="mode == 'v'">Images</label>
                    <FileSelection
                        :images.sync="issue_obj.images"
                        :filter="val => val.image_type == undefined || val.image_type == null || val.image_type == 'p'"
                        :read_only="mode != 'e'"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.images">
                        {{ api_errors.images.join(', ') }}
                    </small>
                </vs-col>
            </vs-row>
        </div>
        <vs-row class="mt-base" v-if="show_action_buttons && show_review && $store.state.is_online">
            <vs-col class="text-center">
                <vs-button @click="$emit('reject')" type="filled" color="primary" class="mx-2">
                    Reject
                </vs-button>
                <vs-button @click="$emit('approve')" type="filled" color="primary" class="mx-2">
                    Approve
                </vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import SelectDate  from '../../../components/letstream/ls-select-date/SelectDate.vue'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import FileSelection from '../Components/FileSelection.vue'

export default {
    components: { 
        SelectDate,
        VueTimepicker,
        FileSelection
    },
    props: {
        issue: {
            required: true,
            type: Object
        },
        api_errors: {
            required: true,
            type: Object
        },
        mode: {
            required: true,
            type: String
        },
        show_action_buttons: {
            required: true,
            type: Boolean
        },
        show_review: {
            required: true,
            type: Boolean
        },
        manager_dropdown: {
            required: true,
            type: Function
        }
    },
    data () {
        return {
            issue_obj: null,
            default_data: {
                direction: null,
                date_of_accident: new Date(Date.now()),
                chainage_from: null,
                chainage_to: null,
                time: '',
                incident: null,
                action_taken: null,
                remarks: null
            },
        }
    },
    watch: {
        issue: {
            deep: true,
            handler: function (newV) {
                this._set_by_watcher = true
                this.update_issue_obj(newV)
            }
        },
        issue_obj: {
            deep: true,
            handler: function (newV) {
                if (this._set_by_watcher) {
                    this._set_by_watcher = false
                    return
                }
                this.$emit('update:issue', newV)
            }
        }
    },
    mounted() {
        this.update_issue_obj(this.issue)
    },
    methods: {
        update_issue_obj(new_data) {
            if (!new_data) this.issue_obj = null
            else {
                let issue_obj = {...new_data}
                if (!issue_obj.data)
                    issue_obj.data = this.deepclone(this.default_data)
                
                this.issue_obj = issue_obj
            }
        },
        current_date() {
            const date = new Date()
            const day = date.getDate()
            const month = date.toLocaleString('default', { month: 'short' });
            const year = date.getFullYear()

            return `${day}-${month}-${year}`
        }
    },
}
</script>
